'use client';

import { c as _c } from "react/compiler-runtime";
import { segmentClassName, segmentedTrackClassName } from '@/components/ui/segmented-control';
import { cn } from '@/utils/tailwindcss-override';
import { Tab, TabList } from '@headlessui/react';
import type React from 'react';

/**
 * The dashboard's sections, within a Headless UI TabGroup, as a segmented control with what
 * is still open behind each section. Where the row does not fit it scrolls sideways rather
 * than wrapping into a second track. The keyboard moves with the arrow keys.
 */
export const DashboardTabList: React.FC<{
  tabs: {
    label: string;
    /** An icon or the area's dot in front of the label. */
    marker: React.ReactNode;
    open?: number;
    openLabel?: string;
  }[];
  label: string;
}> = t0 => {
  const $ = _c(6);
  const {
    tabs,
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(segmentedTrackClassName, "w-fit max-w-full overflow-x-auto");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== tabs) {
    t2 = tabs.map(_temp2);
    $[1] = tabs;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label || $[4] !== t2) {
    t3 = <TabList aria-label={label} className={t1}>{t2}</TabList>;
    $[3] = label;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(t0) {
  const {
    selected
  } = t0;
  return cn(segmentClassName(selected), "shrink-0 gap-2 px-3 text-sm whitespace-nowrap", selected && "font-semibold");
}
function _temp2(tab) {
  return <Tab key={tab.label} className={_temp}><span className="hidden w-4 shrink-0 justify-center @xl/dashboard:flex">{tab.marker}</span>{tab.label}{tab.open !== undefined && tab.open > 0 && <><span aria-hidden={true} className="bg-chip text-heading inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold tabular-nums">{tab.open}</span><span className="sr-only">{tab.openLabel}</span></>}</Tab>;
}